import enums from './Enums';
import moment from 'moment';

const PREFIX_TRANSAKCIJSKI = 'T';
const NAPLATNI_UREDAJ = 3;

// Fiskalizacija 2.0 effective date - from this date, transakcijski uses oznaka prostora like fiskalni
const FISKALIZACIJA_2_DATE = '2026-01-01';

export function calculateBrojRacuna(racun) {
    let prefixPoslovnogProstora = racun.poslovnica.oznakaPoslovnogProstora[0];
    let brojPoslovnice = racun.poslovnica.brojPoslovnice;

    if (racun.tipRacuna === enums.tipRacuna.FISKALNI_RACUN) {
        let brojRacuna = racun.rbrFiskalniRacun.split('-')[0];
        return brojRacuna + '/' + prefixPoslovnogProstora + brojPoslovnice + '/' + NAPLATNI_UREDAJ;
    } else {
        let brojRacuna = racun.rbrTransakcijskiRacun.split('-')[0];

        // Fiskalizacija 2.0: From 2026, transakcijski uses same oznaka prostora as fiskalni
        // Before 2026, transakcijski used 'T' prefix (not fiscalized separately)
        let datumRacuna = moment(racun.datumIVrijeme);
        let isFiskalizacija2 = datumRacuna.isSameOrAfter(FISKALIZACIJA_2_DATE);
        let prefix = isFiskalizacija2
            ? prefixPoslovnogProstora + brojPoslovnice  // Same as fiskalni: e.g., "P2"
            : PREFIX_TRANSAKCIJSKI + brojPoslovnice;    // Legacy format: e.g., "T2"

        return brojRacuna + '/' + prefix + '/' + NAPLATNI_UREDAJ;
    }
}
